import React, { useState } from 'react';
import { Menu } from '@material-ui/core';

const RolCell = ({ TriggerComponent, children, anchorOrigin }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const openMenu = event => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const closeMenu = () => {
    setAnchorEl(null);
  };

  return (
    <React.Fragment>
      <div className="pointer">
        <TriggerComponent.type {...TriggerComponent.props} onClick={openMenu} />
      </div>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={closeMenu}
        anchorOrigin={anchorOrigin}
        transformOrigin={anchorOrigin}>
        {children}
      </Menu>
    </React.Fragment>
  );
};

export default RolCell;
